import { render, staticRenderFns } from "./Shippers.vue?vue&type=template&id=54d18084&"
import script from "./Shippers.vue?vue&type=script&lang=js&"
export * from "./Shippers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54d18084')) {
      api.createRecord('54d18084', component.options)
    } else {
      api.reload('54d18084', component.options)
    }
    module.hot.accept("./Shippers.vue?vue&type=template&id=54d18084&", function () {
      api.rerender('54d18084', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Components/Editor/Study/Shippers.vue"
export default component.exports